import { observer } from "mobx-react";
import React from "react";
import FieldEditorStore from "../../FieldEditorStore";
import { ListItemIds } from "../../types";
import CustomFieldConstraints from "./CustomField";
import LegacyLinkedContentConstraints from "./LegacyLinkedContent";
import LinkedContentConstraints from "./LinkedContent";
import ListOfItemsConstraints from "./ListOfItems";
import ListOfNumberValuesConstraints from "./ListOfNumberValues";
import ListOfTextValuesConstraints from "./ListOfTextValues";
import HtmlPlainTextConstraints from "./LongTexts";
import MediaReferences from "./MediaReferences";
import MultiCustomFieldConstraints from "./MultiCustomField";
import SimpleBoolean from "./SimpleBoolean";
import SimpleDateConstraints from "./SimpleDate";
import SimpleNumberConstraints from "./SimpleNumber";
import SimpleTextConstraints from "./SimpleText";
import Slug from "./Slug";
import TransformableImageConstraints from "./TransformableImage";
import TransformableVideoConstraints from "./TransformableVideo";

export interface ConstraintTabProps {
  id: string;
  fieldToRenderType: ListItemIds;
  fieldEditorStore: FieldEditorStore;
  defaultLang: string;
  constraints: any;
  isArrayChildren: boolean;
  onChangeConstraint(key: string, value: unknown): void;
}

function getConstraintComponent(props: ConstraintTabProps) {
  switch (props.fieldToRenderType) {
    case ListItemIds.SimpleText:
      return <SimpleTextConstraints {...props} />;
    case ListItemIds.ListOfTextValues:
      return <ListOfTextValuesConstraints {...props} />;
    case ListItemIds.SimpleNumber:
      return <SimpleNumberConstraints {...props} />;
    case ListItemIds.ListOfNumberValues:
      return <ListOfNumberValuesConstraints {...props} />;
    case ListItemIds.SimplePlainText:
    case ListItemIds.MarkdownPlainText:
    case ListItemIds.JsonPlainText:
    case ListItemIds.HtmlPlainText:
      return <HtmlPlainTextConstraints {...props} />;
    case ListItemIds.SimpleDate:
      return <SimpleDateConstraints {...props} />;
    case ListItemIds.SimpleBoolean:
      return <SimpleBoolean {...props} />;
    case ListItemIds.CustomField:
      return <CustomFieldConstraints {...props} />;
    case ListItemIds.ImageReference:
    case ListItemIds.VideoReference:
    case ListItemIds.ImageWithMetadata:
    case ListItemIds.VideoWithMetadata:
    case ListItemIds.RawReference:
      return <MediaReferences {...props} />;
    case ListItemIds.TransformableImage:
      return <TransformableImageConstraints {...props} />;
    case ListItemIds.TransformableVideo:
      return <TransformableVideoConstraints {...props} />;
    case ListItemIds.ListOfItems:
      return <ListOfItemsConstraints {...props} />;
    case ListItemIds.LegacyContentReference:
      return <LegacyLinkedContentConstraints {...props} />;
    case ListItemIds.ContentReference:
      return <LinkedContentConstraints {...props} />;
    case ListItemIds.MultiCustomField:
      return <MultiCustomFieldConstraints {...props} />;
    case ListItemIds.Slug:
      return <Slug {...props} />;
    default:
      return null;
  }
}

function ConstraintTab(props: ConstraintTabProps) {
  return <div id={props.id}>{getConstraintComponent(props)}</div>;
}

export default observer(ConstraintTab);
